import axios from 'axios'
import {ACCESS_TOKEN_NAME} from '../config.js';


const axiosInstance=axios;


 axiosInstance.interceptors.request.use(req => {
    req.headers.authorization = localStorage.getItem(ACCESS_TOKEN_NAME) ? 'Bearer '+localStorage.getItem(ACCESS_TOKEN_NAME) : '';
    return req;
})

    axiosInstance.interceptors.response.use(
        res => res,
        err => {
            if(err.response.status === 401) {
                localStorage.removeItem(ACCESS_TOKEN_NAME);
                window.location.href = '/Login';     
            }
            throw err;
        }
    )


export default axiosInstance